import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTerminationForEmployer } from "../../types/Dossier";

export const getEmployerDossierTermination = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerDossierTermination", dossierId],
    queryFn: (): Promise<DossierTerminationForEmployer> => {
      return fetchWithAuth<DossierTerminationForEmployer>(
        "getEmployerDossierTermination",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
